<template>
  <div class="container">
    <el-container> 
        <el-header height="100px">
            <img src="static/image/banner1.jpg" alt="banner" class="banner-section" >
        </el-header>
        <el-main>
            <!-- 步骤条 -->
            <el-steps :active="0" process-status="process" align-center class="m-t-20">
                <el-step title="媒體嘉賓注册"></el-step>
                <el-step title="資料稽核"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>

            <el-form label-width="120px" :rules="rules" ref="ruleForm" :model="FormData" label-position="top">
            <!-- 基本資訊表单 -->
            <el-card class="box-card">
                <div slot="header" class="t-a-left">
                    <span>基本資訊</span>
                </div>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="姓名" prop="contact" class="left-align-label">
                                <el-input placeholder="請輸入姓名" v-model="FormData.contact" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="身份證件號碼" label-width="auto" prop="card_no" class="left-align-label">
                                <el-input placeholder="請輸入身份證件號碼" v-model="FormData.card_no" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="性别" label-width="auto" prop="gender" class="left-align-label">
                                <el-select v-model="FormData.gender" placeholder="請選擇" class="block">
                                    <el-option key="male" label="男" value="male"></el-option>
                                    <el-option key="female" label="女" value="female"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="所在國家/城市" label-width="auto" prop="country" class="left-align-label">
                                <el-input placeholder="請輸入所在國家/城市" v-model="FormData.country" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>   
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫地址" label-width="auto" prop="contact_address" class="left-align-label">
                                <el-input placeholder="請輸入聯繫地址" v-model="FormData.contact_address" maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>   
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="出生日期" label-width="auto" prop="birthday" class="left-align-label">
                                <el-date-picker v-model="FormData.birthday" type="date" placeholder="選擇日期" value-format="yyyy-MM-dd"> </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="card-img">
                                    <div>
                                        <el-form-item label="身份證正面" label-width="auto" prop="card_front" class="left-align-label ">
                                        <el-upload
                                            :action="upload_url"
                                            :before-upload="handleBeforeUpload"
                                            accept="image/*"
                                            :show-file-list="false"
                                            :on-success="handleSuccess"
                                            :on-error="handleError"
                                            :on-change="handleFileChange"
                                            list-type="picture-card"
                                            :data="{'field':'card_front','is_tmp':'1'}"
                                        >
                                        <img v-if="FormData.card_front" :src="FormData.card_front" class="business-uploader" style="height: 150px">
                                        <i v-else class="el-icon-plus"></i>
                                        </el-upload>  
                                        </el-form-item>
                                    </div>                              
                                    <div>
                                        <el-form-item label="身份證背面" label-width="auto" prop="card_back" class="left-align-label ">
                                        <el-upload
                                            :action="upload_url"
                                            :before-upload="handleBeforeUpload"
                                            accept="image/*"
                                            :show-file-list="false"
                                            :on-success="handleSuccess"
                                            :on-error="handleError"
                                            :on-change="handleFileChange"
                                            list-type="picture-card"
                                            :data="{'field':'card_back','is_tmp':'1'}"
                                        >
                                        <img v-if="FormData.card_back" :src="FormData.card_back" class="business-uploader" style="height: 150px">
                                        <i v-else class="el-icon-plus"></i>
                                        </el-upload>
                                        </el-form-item>
                                    </div>
                                </div>
                        </el-col>
                    </el-row>

            </el-card>

            <el-card class="box-card">
                <div slot="header" class="t-a-left">
                    <span>工作資訊</span>
                </div>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="所屬媒體" class="left-align-label" prop="name">
                                <el-input placeholder="請輸入所屬媒體" v-model="FormData.name" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="辦公地址" class="left-align-label" prop="address">
                                <el-input placeholder="請輸入辦公地址" v-model="FormData.address" maxlength="200"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫電話" class="left-align-label" prop="phone">
                                <el-input placeholder="請輸入聯繫電話" v-model="FormData.phone" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="職務" class="left-align-label" prop="position">
                                <el-input placeholder="請輸入職務" v-model="FormData.position" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                            <el-form-item label="聯繫郵箱" class="left-align-label" prop="email">
                                <el-input placeholder="請輸入聯繫郵箱" v-model="FormData.email" maxlength="100"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item label="證明" label-width="auto" prop="work_id" class="left-align-label">
                                                                
                                <el-upload
                                    :action="upload_url"
                                    :before-upload="handleBeforeUpload"
                                    accept="image/*"
                                    :show-file-list="false"
                                    :on-success="handleSuccess"
                                    :on-error="handleError"
                                    :on-change="handleFileChange"
                                    list-type="picture-card"
                                    :data="{'field':'work_id','is_tmp':'1'}"
                                >
                                <img v-if="FormData.work_id" :src="FormData.work_id" class="business-uploader" style="height: 150px">
                                <i v-else class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item>
                                <el-button type="primary" @click="submitForm('ruleForm')" disabled>提交</el-button>
                                <el-button @click="resetForm('ruleForm')">重設</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
            </el-card>
            </el-form>
            
        </el-main>
    </el-container>
    <!-- 左侧导航栏 -->
    <!-- <el-aside width="200px">
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo">
        <el-menu-item index="1">
          <i class="el-icon-s-home"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-s-platform"></i>
            <span>产业嘉宾</span>
          </template>
          <el-menu-item index="2-1">产业嘉宾注册</el-menu-item>
          <el-menu-item index="2-2">产业嘉宾证件申报</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-s-flag"></i>
            <span>展会</span>
          </template>
        </el-submenu>
        <el-menu-item index="4">
          <i class="el-icon-user"></i>
          <span slot="title">My Page</span>
        </el-menu-item>
      </el-menu>
    </el-aside> -->

  </div>
</template>

<script>
  import setting from '@/setting'
  import {submitGuest} from '@/api/guest'
export default {
    data() {
        return {
            activeMenu: '2-1',
            dialogImageUrl: '',
            dialogVisible: false,
            upload_url: setting.apiBaseURL + '/upload',
            FormData: {
                type:'media',
                contact: '',
                gender: '',
                card_no:'',
                country: '',
                contact_address: '',
                birthday: '',
                work_id:'',
                card_front:'',
                card_back:'',
                name: '',
                address: '',
                phone: '',
                position: '',
                email: '',
            },
            rules: {
                contact: [
                    { required: true, message: '請輸入姓名', trigger: 'blur' }
                ],
                card_no: [
                    { required: true, message: '請輸入身份證件號碼', trigger: 'blur' }
                ],
                gender: [
                    { required: true, message: '請選擇性别', trigger: 'blur' }
                ],
                country: [
                    { required: true, message: '請輸入所在國家/城市', trigger: 'blur' }
                ],
                contact_address: [
                    { required: true, message: '請輸入聯繫地址', trigger: 'blur' }
                ],
                birthday: [
                    { required: true, message: '請選擇出生日期', trigger: 'blur' }
                ],
                work_id: [
                    { required: true, message: '請上傳證明', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '請輸入所屬媒體', trigger: 'blur' },
                    { min: 1,max: 100, message: '100个字以内', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '請輸入辦公地址', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '請輸入聯繫電話', trigger: 'blur' }
                ],
                position: [
                    { required: true, message: '請輸入職務', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '請輸入聯繫郵箱', trigger: 'blur' }
                ],
                card_front: [
                    { required: true, message: '請上傳身份證正面', trigger: 'blur' }
                ],
                card_back: [
                    { required: true, message: '請上傳身份證背面', trigger: 'blur' }
                ],
            },
        };
    },
    methods: {
        submitForm(formName) {
            return false;
            this.$refs[formName].validate((valid) => {
            if (valid) {
                // 显示提交确认对话框
                this.$confirm('確認提交資料嗎？ <br>   Do you want to confirm and submit your application? ', '確認提交 Confirm Submission', {
                    confirmButtonText: '確認 Confirm',
                    cancelButtonText: '取消 Cancel',
                    type: 'warning',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    // 用户点击确认
                    this.processSubmit()
                }).catch(() => {
                    // return
                })
            } else {
                return false;
            }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async processSubmit () {
            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: '資料提交中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            try {
                submitGuest(this.FormData).then(res => {
                    if (loading) {
                        loading.close()
                    }
                    if (res.status==200) {
                        this.$confirm(res.msg, '資料提交成功。Submission Successful.', {
                            confirmButtonText: '確認 Confirm',
                            cancelButtonText: '',
                            type: 'success',
                            showCancelButton: false,
                            dangerouslyUseHTMLString: true
                        }).then(() => {
                            // 用户点击确认
                            this.resetForm('ruleForm')
                        }).catch(() => {
                            // return
                        })
                    } else {
                        // 提交失败
                        this.$message.error(res.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
                    }
                }).catch (error=> {      
                    if (loading) {
                        loading.close()
                    }
                    // 提交失败
                    this.$message.error(error.msg || '提交失敗，請檢查網絡連接。Submission Failed. Please check your network connection.')
                }) 
                // // 发送提交请求
                // const response = await fetch(`${setting.apiBaseURL}/submit_guest`, {
                //     method: 'POST',
                //     headers: {
                //     'Content-Type': 'application/json'
                //     },
                //     body: JSON.stringify(this.FormData)
                // })
                // const result = await response.json()
                // // 关闭加载状态
                // loading.close()
        
                // if (result.status==200) {
                //     // 提交成功
                //     this.$message.success('資料提交成功。Submission Successful.')
                //     // 可以选择跳转到成功页面或重置表单
                //     // this.$router.push('/success')
                //     // 或者重置表单
                //     this.resetForm('ruleForm')
                // } else {
                //     // 提交失败
                //     this.$message.error(result.msg || '提交失敗，請稍後重試。Submission Failed. Please try again later.')
                // }
            } catch (error) {
                // 关闭加载状态
                if (loading) {
                    loading.close()
                }
                console.error('提交失敗:', error)
                this.$message.error('提交失敗，請檢查網絡連接後重試。Submission Failed. Please check your network connection and try again later.')
            }
        },
        handleBeforeUpload (file) {
            if (file.size > 10 * 1024 * 1024) {
            this.$message.error('文件大小不能超過10MB')
            return false
            }
        },
        handleSuccess (rep, file, fileList) {
            console.log('handleSuccess')
            console.log(rep, file, fileList)
            if (typeof rep !== 'undefined' && typeof rep.status !== 'undefined' && rep.status === 200) {
            if (typeof rep.data.field !== 'undefined' && rep.data.url) {
                this.$set(this.FormData, rep.data.field, rep.data.url)
            }
            }
        },
        handleError (err, file, fileList) {
            console.log(err, file, fileList)
        },
        handleFileChange (file, fileList) {
            console.log('handleFileChange', file)
            console.log(file, fileList)
        },
    }
};
</script>

<style scoped>
.container {
    width: 100%;
    /* height: 100vh; 占满全屏 */
    display: flex;
    overflow: hidden;
    background: #f5f8ff; /* 全页面背景色 */
    scrollbar-width: none; /* Firefox */
}
.container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}
.el-header{
    padding: 0;
}
.banner-section{
    width: 100%;
}
/* 样式部分 */
.el-aside {
  background-color: #f5f7fa;
}

.el-main {
    padding: 20px;
    margin: 20px;
    background-color: white; /* 表单部分背景色 */
    padding: 20px; /* 添加内边距以确保内容与边缘有间距 */
    border-radius: 30px; /* 圆角效果 */
}
.box-card{
    margin:30px 50px;
}
.el-card__body{
    padding: 20px;
}
.t-a-left{
    text-align: left;
}
.m-t-20{
    margin-top: 20px;
}
.left-align-label{
  text-align: left !important; /* 强制左对齐 */
}
.card-img {
    display: flex;
    justify-content: left;
    gap: 20px;
}
.card-img-tip{
    text-align: center;
    color: #999;
}
</style>


// WEBPACK FOOTER //
// src/pages/guest/media/register.vue